var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M40,20A20,20,0,1,1,20,0,20,20,0,0,1,40,20Z",
    transform: "translate(0)",
    fill: "#325ae7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M28.346,21.154V21.3a9.232,9.232,0,0,1-1.72,5.264,7.2,7.2,0,0,1-.656.8l-.8.8-.368.376h0L14.05,39.306A18.84,18.84,0,0,1,.81,26.066l11.92-11.92a9.36,9.36,0,0,1,12.464,0l.8.8a9.248,9.248,0,0,1,2.344,5.448,3.624,3.624,0,0,1,0,.416C28.346,20.906,28.346,21.026,28.346,21.154Z",
    transform: "translate(-0.162 0.046)",
    fill: "#0832c7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M32.882,21.318l-4,5.344v-.048l-2.536-3.3-1.5-2h1.912V21.23a5.48,5.48,0,0,0-.256-1.664,5.648,5.648,0,1,0-1.136,5.36l2.3,3.048a9.384,9.384,0,1,1,2.68-8.408A8.8,8.8,0,0,1,30.5,21.23v.088Z",
    transform: "translate(-0.977 -1.164)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2bd8f46b06f13b3abc87706cbda5d332.svg";
export { ForwardRef as ReactComponent };